import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Container } from 'react-bootstrap';

import TopNavBar from '../../core/components/TopNavBar';
import WaitingRoomsList from '../components/WaitingRoomsList';
import AddWaitingRoom from '../components/AddWaitingRoom';
import LoginContainer from './LoginContainer';
import handleAutoLogin from '../utils/login';
import { getWaitingRooms } from '../actions/waiting-rooms';
import { selectHttpInfo } from '../../core/selectors/http';
import { selectIsLoggedIn } from '../selectors/auth';
import {
    GET_WAITING_ROOMS_REQUEST_NAME, UPSERT_WAITING_ROOM_REQUEST_NAME, DELETE_WAITING_ROOM_REQUEST_NAME,
} from '../api/config';

const WaitingRoomsPage = () => {
    const dispatch = useDispatch();
    const [selectedWaitingRoom, setSelectedWaitingRoom] = useState(null);
    const [hasAccess, setHasAccess] = useState(true);
    const [page, setPage] = useState(1);
    const [searchInput, setSearchInput] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const isLoggedIn = useSelector(selectIsLoggedIn);

    const getHttpInfo = useSelector((state) => selectHttpInfo(state, GET_WAITING_ROOMS_REQUEST_NAME));
    const upsertHttpInfo = useSelector((state) => selectHttpInfo(state, UPSERT_WAITING_ROOM_REQUEST_NAME));
    const deleteHttpInfo = useSelector((state) => selectHttpInfo(state, DELETE_WAITING_ROOM_REQUEST_NAME));

    useEffect(() => {
        handleAutoLogin(dispatch);
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDebouncedSearchTerm(searchInput.trim());
        }, 600);

        return () => clearTimeout(timeoutId);
    }, [searchInput]);

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(getWaitingRooms(setHasAccess, page, debouncedSearchTerm));
        }
        return undefined;
    }, [debouncedSearchTerm, dispatch, isLoggedIn, page]);

    if (!isLoggedIn) {
        return <LoginContainer />;
    }

    return (
        <>
            <TopNavBar />
            <Container>
                {hasAccess
                    ? <>
                        <WaitingRoomsList
                            setSelectedWaitingRoom={setSelectedWaitingRoom}
                            currentPage={page}
                            onPageChange={setPage}
                            searchTerm={searchInput}
                            isFetching={
                                getHttpInfo.isFetching || deleteHttpInfo.isFetching || upsertHttpInfo.isFetching
                            }
                            isError={getHttpInfo.isError || deleteHttpInfo.isError || upsertHttpInfo.isError}
                            onSearchChange={(value) => {
                                setSearchInput(value);
                                setPage(1);
                            }}
                        />
                        <AddWaitingRoom
                            selectedWaitingRoom={selectedWaitingRoom} setSelectedWaitingRoom={setSelectedWaitingRoom}
                        />
                    </>
                    : <Alert className='mt-5' variant='danger'>Nu ai drepturi sa accesezi aceasta pagina.</Alert>
                }
            </Container>
        </>
    );
};

export default WaitingRoomsPage;
